import { IoIosLink,IoIosShareAlt } from "react-icons/io";
import { MdShare } from "react-icons/md";
const ShareButton = ({ title, text, url }) => {
    const handleShare = async () => {
      if (navigator.share) {
        try {
          await navigator.share({ 
            url,
          });
          console.log("Content shared successfully");
        } catch (error) {
        
        }
      } else {
      
      }
    };
  
    return<div title="Share" className="button-ui0 p-0 cursor" onClick={handleShare}><MdShare className='icon'/> </div>  ;
  };
  
  export default ShareButton;
  